var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8008 66.9001H40.1341",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9675 56.3249V77.9915",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.86 10.9119L54.73 11.2152L42.1633 40.3786H29.8133C26.8667 40.3786 24.05 40.9852 21.4933 42.0686L29.0767 23.9552L29.25 23.5219L29.5533 22.8286C29.64 22.5686 29.7267 22.3086 29.8567 22.0919C35.5333 8.96191 41.9467 5.97191 54.86 10.9119Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2167 41.2453C76.2667 40.6386 74.1867 40.3786 72.1067 40.3786H42.1633L54.73 11.2153L54.86 10.9119C55.51 11.1286 56.1167 11.4319 56.7667 11.6919L66.3433 15.7219C71.6733 17.9319 75.4 20.2286 77.6533 23.0019C78.0867 23.5219 78.4333 23.9986 78.7367 24.5619C79.1267 25.1686 79.43 25.7753 79.6033 26.4253C79.7767 26.8153 79.9067 27.2053 79.9933 27.5519C81.1633 31.1919 80.47 35.6553 78.2167 41.2453Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2608 61.5262V69.9762C93.2608 70.8429 93.2174 71.7095 93.1741 72.5762C92.3508 87.6995 83.9008 95.3262 67.8674 95.3262H34.0674C33.0274 95.3262 31.9874 95.2395 30.9908 95.1095C17.2108 94.1995 9.8441 86.8329 8.9341 73.0529C8.8041 72.0562 8.71744 71.0162 8.71744 69.9762V61.5262C8.71744 52.8162 14.0041 45.3195 21.5441 42.0695C24.1441 40.9862 26.9174 40.3795 29.8641 40.3795H72.1574C74.2808 40.3795 76.3608 40.6829 78.2674 41.2462C86.8908 43.8896 93.2608 51.9495 93.2608 61.5262Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0767 23.9553L21.4933 42.0686C13.9533 45.3186 8.66666 52.8153 8.66666 61.5253V48.8286C8.66666 36.5219 17.42 26.2519 29.0767 23.9553Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2472 48.8265V61.5232C93.2472 51.9899 86.9206 43.8865 78.2539 41.2865C80.5072 35.6532 81.1572 31.2332 80.0739 27.5499C79.9872 27.1599 79.8572 26.7699 79.6839 26.4232C87.7439 30.5832 93.2472 39.1199 93.2472 48.8265Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCard);
export default __webpack_public_path__ + "static/media/purchase-card.2ea5dcbc39f78e676061b96291d3002b.svg";
export { ForwardRef as ReactComponent };